// import React, { useEffect, useState } from 'react'
import React from 'react'
import { Helmet } from "react-helmet-async";
import { HashLink as Link } from 'react-router-hash-link'

// import { Container } from '@govtechsg/sgds-react/Container'
import { Card } from '@govtechsg/sgds-react/Card'
import { Button } from '@govtechsg/sgds-react/Button'
import { Row } from '@govtechsg/sgds-react/Row'

// Icons
import search from '../images/icons/search.png'
import geocode from '../images/icons/revgeocode.png'
import populationQuery from '../images/icons/population.png'
// import resources from '../images/icons/resources.png'
import routing from '../images/icons/routing.png'
import planning from '../images/icons/planning.png'
import theme from '../images/icons/theme.png'
import coordinates from '../images/icons/coordinates.png'
import contactus from '../images/contactus.png'
import advminimap from '../images/illus-AdvMiniMap.png'
import basemap from '../images/illus-Basemap.png'
import minimap from '../images/illus-minimap.png'
import staticmap from '../images/illus-StaticMap.png'
import intro from '../images/LandingPage.jpg'

// Components
import HeaderRegComponent from '../Components/HeaderRegComponent'
import FooterComponent from '../Components/FooterComponent'
import NotificationComponent from '../Components/NotificationComponent'

// icons
import { handleEvtClicks, handlePageViews } from './helper'


const Home = () => {
  // const[showNotification, setShowNotification] = useState(false)

  // const ModalNotification = () => {
  //   return (
  //     <Modal show={showNotification} centered centeredAlignVariant size='lg'>
  //       <Modal.Body className='moving-modal-body' style={{ width: '100%' }}>
  //         <div>
  //           <h1 className='moving-header'>We have updated!</h1>
  //           <p className='moving-content'>To give you a better experience and to strengthen security measures,<br />
  //             we have released this new API page.<br /><br />
  //             Here you will find
  //             <ul>
  //               <li>An updated landing page</li>
  //               <li>An updated API document</li>
  //               <li>APIs with new endpoints and increased security</li>
  //             </ul>
  //             The old API documentation and APIs will be deprecated on <strong>29 September 2023.</strong> 
  //           </p>
  //         </div>
  //         <Button
  //           style={{
  //             color: '#FFFFFF',
  //             backgroundColor: '#F5333F',
  //             border: '#F5333F',
  //             paddingLeft: '40px',
  //             paddingTop: '15px',
  //             paddingRight: '40px',
  //             paddingBottom: '15px',
  //             fontWeight: '700',
  //             fontSize: '18px'
  //           }}
  //           onClick={() => setShowNotification(false)}
  //         >
  //           Got it, thanks!
  //         </Button>
  //         <br /><br />
  //       </Modal.Body>
  //     </Modal>
  //   )
  // }

  handlePageViews();

  const APIDocs = [
    { id: 1, logo: search, header: 'SEARCH', desc: 'Search for address information for roads, buildings etc.', subID: 'search', link:'search' },
    { id: 3, logo: geocode, header: 'REVERSE GEOCODE', desc: 'Get the corresponding address or road name for a location.', subID: 'reverseGeocode', link:'om-reverseGeocode-section'},
    { id: 4, logo: routing, header: 'ROUTING', desc: 'Enable public transport (PT), driving, walking and cycling routes across Singapore.', subID: 'routing', link: 'om-routing-section' },
    { id: 5, logo: coordinates, header: 'COORDINATE CONVERTERS', desc: 'Convert your coordinates between 6 conversion function.', subID: 'coordinate' },
    { id: 6, logo: theme, header: 'THEMES', desc: 'Access over 100 thematic layers of locations for amenities, boundaries, facilities etc.', subID: 'themes' },
    { id: 7, logo: planning, header: 'PLANNING AREA', desc: 'Get the coordinates of the 55 planning areas in Singapore.', subID: 'planningarea' },
    { id: 8, logo: populationQuery, header: 'POPULATION QUERY', desc: 'Singapore population demographics provided by the Department of Statistics.', subID: 'populationquery' }
    // { id: 9, logo: resources, header: 'RESOURCES', desc: 'Tools to help you integrate OneMap APIs.' }
  ]
  const MapServices = [
    {
      id: 1,
      mapIndex: 'Map 1',
      imageSrc: basemap,
      title: 'Basemap',
      subId: 'basemap',
      desc: 'Use OneMap as the basemap layer in your applications. It is updated, localised and granular.' +
      ' The basemap comes in 4 different styles – Default, Original, Grey and Night.'
    },
    {
      id: 2,
      mapIndex: 'Map 2',
      imageSrc: minimap,
      title: 'Minimap',
      subId: 'miniMap',
      desc: 'Build a customised interactive map of an area with a location marker and pop-up box with customisable text' +
      ' and logo image.'
    },
    {
      id: 3,
      mapIndex: 'Map 3',
      imageSrc: advminimap,
      title: 'Advanced Minimap',
      subId: 'advancedMiniMap',
      desc: 'Create an Advanced Minimap for more complex mapping needs. Add up to 15 location markers and include a route between' +
      ' the location markers that are plotted.'
    },
    {
      id: 4,
      mapIndex: 'Map 4',
      imageSrc: staticmap,
      title: 'Static Map',
      subId: 'staticMap',
      desc: 'Create a PNG format map to embed in websites or print materials. This tool enables the overlay of' +
      ' multiple points, polygons, or polylines on the map.'
    } 
  ]
  // useEffect(() => {
  //   // open modal
  //   setShowNotification(true)
  // }, [])
  return (
    <>

      <Helmet>
        <title>OneMap API Documentation</title>
        <meta
          name="description"
          content="	Gain access to Singapore authoritative map data via OneMap API such as search, reverse geocode, population and thematic layer API"
        />
      </Helmet>
    <div className="om-body container-fluid">

      <HeaderRegComponent />
      {/* <ModalNotification /> */}
      <div className="om-body-content pageBase">

        <div id="om-section-introduction" className="om-sections row">

          <NotificationComponent/>
          <div className='col-md-4 col-lg-4 col-xl-4 mt-5 mb-5'>
            <h2>Introduction</h2>
            <p>
              OneMap is the authoritative national map of Singapore developed by the Singapore Land Authority (SLA).
            </p>
            <p>
              We publish a variety of APIs in RESTful JSON format for government agencies, businesses, associations, third
              party developers, researchers, and members of public to use.
            </p>
            <p>
              {/* To use the OneMap APIs and tools&#44; please register here. */}
              These APIs can help you build apps and services by providing authoritative, localised, and granular map and
              map related data.
            </p>
            <p>
              To use the OneMap APIs and tools, please register here.
            </p>

            <Button className='om-btn om-red' href={`${process.env.REACT_APP_PUBLIC_URL}/register`} onClick={()=>{new handleEvtClicks('click', {select: 'Register'})}}>
              Register
            </Button>
          </div>

          <div className='col-md-8 col-lg-8 col-xl-8 mb-5 float-right'>
            <img className="img-fluid float-right" src={intro} alt='intro' />
          </div>
        </div>

        <div id="om-section-mapservices" className='om-sections row'>
          <h2 className='om-red text-center mb-5'>Map Services</h2>

          <div className='row justify-content-center'>
            { MapServices.map((eachMap, index) => {
              return (
                
                    <div key={"om-section-api" + index} className='thumbnail col-12 col-sm-6 col-md-3 '>
                      <Link to={`/maps/#${eachMap.subId}`} state={0} 
                      onClick={()=>{new handleEvtClicks('click', {select: eachMap.subId})}}>
                      <img className="thumbnail-img center" src={eachMap.imageSrc} />
                      <p className='title'>{eachMap.title}</p>
                      <p className='subtitle d-flex'>{eachMap.desc}</p>
                      </Link>
                  </div>
              )
            })}
          </div>
        </div>

        <div id="om-section-apidocument" className='om-sections row'>
          <div className="content-fluid p-5">
            <h2 className="text-center mb-5">API Document</h2>

            <div className='row d-flex align-items-center justify-content-center no-gutters'>
              { 
                APIDocs.map((eachAPI) => {
                  const selectedAPI = {
                    selectedID: eachAPI.id,
                    subID: eachAPI.subID,
                    item: eachAPI.header,
                    link: eachAPI.link
                }
                  // console.log(selectedAPI, 'selectedAPI')
                return (
                  <div key={eachAPI.id} className='om-card col-sm-6 col-md-4 mb-4'>
                    <Row>
                      <Link to={`${selectedAPI.subID}`} state={selectedAPI.selectedID} style={{ textDecoration: 'none' }}
                      onClick={()=>{new handleEvtClicks('click', {select: selectedAPI.item})}}>
                        <div className='card shadow'>
                          <Card.Body style={{marginBottom:'0'}}>
                            <img className="card-icon" src={eachAPI.logo} alt={eachAPI.header} />
                            <Card.Title>{eachAPI.header}</Card.Title>
                            <Card.Text>{eachAPI.desc}</Card.Text>
                          </Card.Body>
                        </div>
                      </Link>
                    </Row>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        <div id="om-section-contactus" className='om-sections row'>
          <div className='col-md-6 mb-5'>
            <br /><br /><br />
            <h2 className="om-orange">Contact Us</h2>
            <br />
            <p>
              The Singapore Land Authority welcomes your feedback to improve our services. If you have any feedback on the use
              of the OneMap APIs, please contact us at <a className="om-email" href="mailto:onemap@sla.gov.sg">onemap@sla.gov.sg</a>
            </p>
            {/* <p>
              Feel free send us feedback at <a className="om-email" href="mailto:onemap@sla.gov.sg">onemap@sla.gov.sg</a> and we would try to get back to you as soon as possible!
            </p> */}
          </div>
          <div className='om-contactus-img-frame col-sm-0 col-md-6'>
            <img src={contactus} alt='Contact Us' />
          </div>
        </div>

      </div>

      <FooterComponent />

    </div>
    </>
  )
}

export default Home